import {initializeApp} from 'firebase/app';
import {connectAuthEmulator, getAuth} from "firebase/auth";
import {getFirestore, connectFirestoreEmulator} from "firebase/firestore";
import {connectFunctionsEmulator, getFunctions} from 'firebase/functions';
import { getStorage, connectStorageEmulator } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyDbOlD0ygupgPBC7PBMmTeIIc1iAMqgD5A",
  authDomain: "portal.comline.app",
  projectId: "clgmbh-portal",
  storageBucket: "clgmbh-portal.appspot.com",
  messagingSenderId: "922131841128",
  appId: "1:922131841128:web:1371521e2ea07ecf3afbdd"
};

const region = 'europe-west3';

const firebase = initializeApp(firebaseConfig);
const auth = getAuth(firebase);
const firestore = getFirestore(firebase);
const functions = getFunctions(firebase, region);
const storage = getStorage(firebase);

if (location.hostname === 'localhost') {
  connectAuthEmulator(auth, 'http://localhost:9998', {disableWarnings: true});
  connectFirestoreEmulator(firestore, 'localhost', 8098);
  connectFunctionsEmulator(functions, 'localhost', 7003);
  connectStorageEmulator(storage, "localhost", 9199);
}

export {auth, functions, storage, firestore};
